// extracted by mini-css-extract-plugin
export default {"Sort":"Sort_Sort__AMlPp","label":"Sort_label__dc1P1"};